import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useClientContext } from '@/context/client'
import { ROUTE_BUILDERS } from '@/config/routes'

export function SignContractPopup() {
  const { showAssinarPopup, setShowAssinarPopup, id_client, setMessage, setIsDialogOpen } = useClientContext()

  if (!showAssinarPopup) return null

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      setMessage({
        type: 'success',
        text: 'O link foi copiado com sucesso.'
      })

      // Se for mobile e suportar compartilhamento nativo
      if (navigator.share && /Android|iPhone|iPad/i.test(navigator.userAgent)) {
        await navigator.share({
          title: 'Assinar contrato',
          text: 'Clique para acessar e assinar a minuta:',
          url: text
        })
      }
    } catch (err) {
      console.error('Erro ao copiar ou compartilhar:', err)
      setMessage({
        type: 'error',
        text: 'Não foi possível copiar o link.'
      })
      setIsDialogOpen(true)
    }
  }

  return (
    <ScrollArea>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-background p-6 rounded-lg shadow-lg w-full max-w-md max-h-screen mx-4">
          <p className="mb-4 text-center">
            Compartilhe o link abaixo com a pessoa para ver a minuta e assinar o contrato:
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 mb-4">
            <Input
              type="text"
              readOnly
              value={`${window.location.origin}${ROUTE_BUILDERS.minute(id_client)}`}
              className="bg-input text-foreground"
            />
            <Button
              onClick={() => copyToClipboard(`${window.location.origin}${ROUTE_BUILDERS.minute(id_client)}`)}
              className="bg-primary text-primary-foreground w-full sm:w-auto"
            >
              Copiar Link
            </Button>
          </div>

          <Button onClick={() => setShowAssinarPopup(false)} className="mt-2 bg-primary text-primary-foreground w-full">
            Fechar
          </Button>
        </div>
      </div>
    </ScrollArea>
  )
}
